/**
 * Syncs auth + org into tracking context and attaches global behavior listeners.
 * Mount once inside Providers (after OrganizationProvider and auth are available).
 */

import { useEffect } from 'react'
import { useAuthStore } from '@/store/authStore'
import { useOrganization } from '@/contexts/OrganizationContext'
import { useTrackingContextStore } from './trackingContextStore'
import { setupBehaviorListeners } from './behaviorListeners'

export function BehaviorTrackingProvider({ children }: { children: React.ReactNode }) {
  const { user, isAuthenticated } = useAuthStore()
  const { currentOrganization } = useOrganization()
  const setContext = useTrackingContextStore((s) => s.setContext)

  // Sync user + org into tracking context
  useEffect(() => {
    setContext({
      user_id: user?.id != null ? String(user.id) : null,
      org_id: currentOrganization?.id ?? null,
      role: user?.role ?? null,
      feature_name: useTrackingContextStore.getState().context.feature_name,
    })
  }, [user?.id, user?.role, currentOrganization?.id, setContext])

  // Attach global listeners once
  useEffect(() => {
    setupBehaviorListeners()
  }, [])

  return <>{children}</>
}
